import React from "react";
import styled from "styled-components";
import FlagA from "./images/FlagA.svg?react";
import FlagB from "./images/FlagB.svg?react";
import FlagC from "./images/FlagC.svg?react";
import FlagD from "./images/FlagD.svg?react";
import FlagE from "./images/FlagE.svg?react";
import FlagF from "./images/FlagF.svg?react";

const FLAG_SIZE_LARGE = "large";
const FlagWrapper = styled.div(({ sizeInPixels }) => ({
  height: `${sizeInPixels}px`,
  "line-height": `${sizeInPixels}px`,
  padding: "0 8px 0 0",
  width: `${sizeInPixels + 8}px`,
}));

export default function WorkOrderFlag({ flag, size }) {
  if (!flag) return null;

  const sizeInPixels = size === FLAG_SIZE_LARGE ? 24 : 16;

  return (
    <FlagWrapper alt={`Flag ${flag}`} data-testid="flag" sizeInPixels={sizeInPixels}>
      {flag === "A" && <FlagA display="block" sizeInPixels={sizeInPixels} />}
      {flag === "B" && <FlagB display="block" sizeInPixels={sizeInPixels} />}
      {flag === "C" && <FlagC display="block" sizeInPixels={sizeInPixels} />}
      {flag === "D" && <FlagD display="block" sizeInPixels={sizeInPixels} />}
      {flag === "E" && <FlagE display="block" sizeInPixels={sizeInPixels} />}
      {flag === "F" && <FlagF display="block" sizeInPixels={sizeInPixels} />}
    </FlagWrapper>
  );
}
